import { datahubPartial } from '@shared/partials/datahub.partial';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { AggregatedMeteredDataQueryResultDto } from '@app/api/dmc';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { productIdentificationPartial } from '@shared/partials/product-identification.partial';
import { unitTypePartial } from '@shared/partials/unit-type.partial';
import { processVariantPartial } from '@shared/partials/process-variant.partial';
import { businessReasonCodePartial } from '@shared/partials/business-reason-code.partial';
import { resolutionPartial } from '@shared/partials/resolution.partial';

export const settlementMeteredTable: TableConfig<AggregatedMeteredDataQueryResultDto> =  {
  id: 'settlement-metered-data',
  title: 'settlement.metered.title',
  saveChanges: true,
  exportable: true,
  copyable: true,
  floatingHeader: true,
  selectable: true,
  selectableType: 'single',
  pageSize: 25,
  columns: [
    {
      title: 'settlement.table.receiveddate',
      key: 'msgCreatedTS',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'settlement.table.startdate',
      key: 'startDate',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'settlement.table.enddate',
      key: 'endDate',
      cellRenderer: DateCellComponent,
    },
    businessReasonCodePartial,
    processVariantPartial,
    resolutionPartial,
    productIdentificationPartial,
    unitTypePartial,
    {
      ...meteringPointTypePartial,
      key: 'typeOfMeteringPoint',
    },
    settlementmethodPartial,
    {
      title: 'settlement.table.version',
      key: 'version'
    },
    datahubPartial,
  ]
}
